<template>
  <div>
    <rest-form-item
      :label="$t('ChannelConfig_Phonovation_Endpoint')"
      prop="endpoint"
    >
      <el-select
        v-model="model.params.endpoint"
        :placeholder="$t('ChannelConfig_Phonovation_Endpoint_Placeholder')"
      >
        <el-option
          v-for="item in endpoints"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        />
      </el-select>
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Phonovation_User')" prop="user">
      <el-input
        v-model="model.params.user"
        :placeholder="$t('ChannelConfig_Phonovation_User_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Phonovation_Password')"
      prop="password"
    >
      <el-input
        v-model="model.params.password"
        :placeholder="$t('ChannelConfig_Phonovation_Password_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Phonovation_ApiId')"
      prop="api_id"
    >
      <el-input
        v-model="model.params.api_id"
        :placeholder="$t('ChannelConfig_Phonovation_ApiId_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Phonovation_ApiVersion')"
      prop="api_version"
      v-if="model.params.endpoint === 'phonovation'"
    >
      <el-select
        v-model="model.params.api_version"
        :placeholder="$t('ChannelConfig_Phonovation_ApiVersion_Placeholder')"
        :default-first-option="false"
      >
        <el-option
          v-for="item in apiVersions"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        />
      </el-select>
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'phonovation')
      this.$set(this.model, 'params', {})
    } else if (this.model.params && this.model.params.endpoint === undefined) {
      this.$set(this.model.params, 'endpoint', 'phonovation')
    }

    if (this.model.params && this.model.params.api_version == null) {
      this.$set(this.model.params, 'api_version', '1.2')
    }
  },

  computed: {
    endpoints() {
      return [
        {
          value: 'phonovation',
          label: this.$t('ChannelConfig_Phonovation_Endpoint_Phonovation')
        },
        {
          value: 'vodafone',
          label: this.$t('ChannelConfig_Phonovation_Endpoint_Vodafone')
        }
      ]
    },
    apiVersions() {
      return [
        {
          value: '1.2',
          label: this.$t('ChannelConfig_Phonovation_ApiVersion_1_2')
        },
        {
          value: '1.3',
          label: this.$t('ChannelConfig_Phonovation_ApiVersion_1_3')
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Phonovation.vue